"use client";

import { CURRENCY_CODE } from "@/lib/constant";
import Script from "next/script";
import { useEffect } from "react";
const TamaraPromoSnippet = ({
  price,
  currency = CURRENCY_CODE,
  lang = "en",
  countryCode = "SA",
  numberOfInstallments = "4"
}) => {
  useEffect(() => {
    // Initialize and render the Tamara product widget after a delay
    const initTamaraWidget = () => {
      if (window.TamaraProductWidget) {
        window.TamaraProductWidget.init({
          lang
        });
        window.TamaraProductWidget.render();
      } else {
        console.error("TamaraProductWidget is not defined");
      }
    };
    const timer = setTimeout(initTamaraWidget, 1000); // Wait for 2 seconds

    // Cleanup timer on unmount
    return () => clearTimeout(timer);
  }, [lang]);
  return <>
      {/* Div where Tamara promo will be rendered */}
      <div className="tamara-product-widget my-4" data-lang={lang} data-price={price} data-currency={currency} data-country-code={countryCode} data-color-type="default" data-show-border="true" data-payment-type="installment" data-number-of-installments={numberOfInstallments} data-disable-installment="false" data-disable-paylater="true" />
      {/* Tamara Promo Script */}
      <Script src="https://cdn.tamara.co/widget/product-widget.min.js" strategy="afterInteractive" onError={e => {
      console.error("Tamara script failed to load", e);
    }} data-sentry-element="Script" data-sentry-source-file="TamaraPromoSnippet.jsx" />
    </>;
};
export default TamaraPromoSnippet;